import DepositModal from 'src/components/Modal/DepositModal';
import LoginModal from 'src/components/Modal/LoginModal';
import ResetPasswordModal from 'src/components/Modal/ResetPasswordModal';
import SignUpModal from 'src/components/Modal/SignupModal';
import { BonusModal } from 'src/components/Modal/BonusModal';
import FreeSpinsModal from 'src/components/Modal/FreeSpinsModal';
import ChangeCurrencyModal from 'src/components/Modal/ChangeCurrencyModal';
import GameNotificationModal from 'src/components/Modal/GameNotificationModal';
import VipRulesModal from 'src/components/Modal/VipRulesModal';
import IosSetupModal from 'src/components/Modal/IosSetupModal';
import SupportModal from 'src/components/Modal/SupportModal';
import HellocleverResultModal from 'src/components/Modal/HellocleverResultModal';
import DepositPaymentInfoModal from 'src/components/Modal/DepositPaymentInfoModal';
import AttentionModal from 'src/components/Modal/AttentionBonusModal';
import NewTournamentModal from 'src/components/Modal/NewTournamentModal';
import FullScreenImageModal from 'src/components/Modal/FullScreenImageModal';
import BackToSignupModal from 'src/components/Modal/BackToSignupModal';
import { LatestDepositsModal } from 'src/components/Modal/LatestDepositsModal';
import { ModalMap } from 'react-easyrocket';
import { SearchModal } from 'src/components/Modal/SearchModal';
import { NoCoinsForFreespinsModal } from 'src/components/Modal/ShopModals/NoCoinsForFreespinsModal';
import { NoCoinsForMoneyModal } from 'src/components/Modal/ShopModals/NoCoinsForMoneyModal';
import { BuyFreespinsModal } from 'src/components/Modal/ShopModals/BuyFreespinsModal';
import { BuyMoneyModal } from 'src/components/Modal/ShopModals/BuyMoneyModal';
import { GameModal } from 'src/modules/GPTGame/components/GameModal';
import { NoCoinsForFreespinsEventModal } from 'src/components/Modal/EventShopModals/NoCoinsForFreespinsEventModal';
import { NoCoinsForMoneyEventModal } from 'src/components/Modal/EventShopModals/NoCoinsForMoneyEventModal';
import { BuyFreespinsEventModal } from 'src/components/Modal/EventShopModals/BuyFreespinsEventModal';
import { BuyMoneyEventModal } from 'src/components/Modal/EventShopModals/BuyMoneyEventModal';
import { ProfileRequirementsModal } from 'src/components/Modal/ProfileRequirementsModal';
import { EventModal } from 'src/components/Modal/EventModal/EventModal';
import { EvolutionWarning } from 'src/components/Modal/EvolutionWarning';
import { JackpotsWin } from 'src/components/Modal/JackpotsWin';
import { NewLocalTournament } from 'src/components/Modal/NewLocalTournament';
import { TournamentRequiredLevel } from 'src/components/Modal/TournamentRequiredLevel';
import FormFields from 'src/components/Modal/FormFields';
import { WinnerTournamentModal } from 'src/components/Modal/WinnerTournament';
import { ConfirmBonusModal } from 'src/components/Modal/ConfirmBonusModal';
import GPTGameModal from 'src/modules/gptGameModal';

export type ModalMapKeys =
  | 'DEPOSIT'
  | 'SIGNUP'
  | 'LOGIN'
  | 'BALANCE_CHANGE_CURRENCY'
  | 'FORM_FIELDS'
  | 'DEPOSIT_HELLOCLEVER_RESULT'
  | 'FREESPINS'
  | 'RESET_PASSWORD'
  | 'BACK_TO_SIGNUP'
  | 'BONUS'
  | 'CONFIRM_BONUS_MODAL'
  | 'ATTENTION_BONUS'
  | 'NEW_TOURNAMENT'
  | 'NEW_LOCAL_TOURNAMENT'
  | 'TOURNAMENT_LOW_LEVEL'
  | 'FULLSCREEN_IMAGE'
  | 'TOURNAMENT_WIN'
  | 'VIP_RULES'
  | 'IOSSETUP'
  | 'DEPOSIT_PAYMENT_INFO'
  | 'GAME_NOTIFICATION'
  | 'SUPPORT'
  | 'LATEST_DEPOSIT_MODAL'
  | 'SEARCH'
  | 'NO_COINS_FOR_FREESPIN'
  | 'NO_COINS_FOR_MONEY'
  | 'BUY_FREESPINS'
  | 'BUY_MONEY'
  | 'GPT_GAME_MODAL'
  | 'NO_COINS_FOR_FREESPIN_EVENT'
  | 'NO_COINS_FOR_MONEY_EVENT'
  | 'BUY_FREESPINS_EVENT'
  | 'BUY_MONEY_EVENT'
  | 'EVENT_MODAL'
  | 'PROFILE_REQUIREMENTS'
  | 'EVOLUTION_WARNING'
  | 'JACKPOTS_WIN';

export const MODAL_MAP: ModalMap<ModalMapKeys> = {
  // Модалки, относящиеся к авторизации. Имеют самый высокий приоритет.
  LOGIN: {
    name: 'LOGIN',
    component: () => <LoginModal />,
    authOnly: false,
    priority: 1
  },
  SIGNUP: {
    name: 'SIGNUP',
    component: () => <SignUpModal />,
    authOnly: false,
    priority: 1
  },
  RESET_PASSWORD: {
    name: 'RESET_PASSWORD',
    component: () => <ResetPasswordModal />,
    authOnly: false,
    priority: 1
  },

  // Модалки, относящиеся к депозиту. Имеют самый высокий приоритет на равне с регистрацией.
  DEPOSIT: {
    name: 'DEPOSIT',
    component: () => <DepositModal />,
    authOnly: false,
    priority: 1
  },
  FORM_FIELDS: {
    name: 'FORM_FIELDS',
    component: () => <FormFields />,
    authOnly: false,
    priority: 2
  },
  LATEST_DEPOSIT_MODAL: {
    name: 'LATEST_DEPOSIT_MODAL',
    component: () => <LatestDepositsModal />,
    authOnly: false,
    priority: 3
  },
  DEPOSIT_HELLOCLEVER_RESULT: {
    name: 'DEPOSIT_HELLOCLEVER_RESULT',
    component: () => <HellocleverResultModal />,
    authOnly: false,
    priority: 3
  },
  DEPOSIT_PAYMENT_INFO: {
    name: 'DEPOSIT_PAYMENT_INFO',
    component: () => <DepositPaymentInfoModal />,
    authOnly: false,
    priority: 3
  },
  // Модалки, относящиеся к начислениям бонусов и фриспинов. Имеют достаточно высокий приоритет.
  BONUS: {
    name: 'BONUS',
    component: () => <BonusModal />,
    authOnly: false,
    priority: 20
  },
  CONFIRM_BONUS_MODAL: {
    name: 'CONFIRM_BONUS_MODAL',
    component: () => <ConfirmBonusModal />,
    authOnly: false,
    priority: 20
  },
  FREESPINS: {
    name: 'FREESPINS',
    component: () => <FreeSpinsModal />,
    authOnly: false,
    priority: 20
  },

  // Модалки, относящиеся к изменению активной валюты пользователя. Имеют средний приоритет.
  BALANCE_CHANGE_CURRENCY: {
    name: 'BALANCE_CHANGE_CURRENCY',
    component: () => <ChangeCurrencyModal />,
    authOnly: false,
    priority: 50
  },
  ATTENTION_BONUS: {
    name: 'ATTENTION_BONUS',
    component: () => <AttentionModal />,
    authOnly: false,
    priority: 50
  },

  // Все остальные модалки. Имеют чуть ниже среднего - низкий приоритет.
  GPT_GAME_MODAL: {
    name: 'GPT_GAME_MODAL',
    component: () => <GPTGameModal />,
    authOnly: false,
    priority: 60
  },
  NEW_TOURNAMENT: {
    name: 'NEW_TOURNAMENT',
    component: () => <NewTournamentModal />,
    authOnly: false,
    priority: 60
  },
  NEW_LOCAL_TOURNAMENT: {
    name: 'NEW_LOCAL_TOURNAMENT',
    component: () => <NewLocalTournament />,
    authOnly: false,
    priority: 60
  },
  TOURNAMENT_WIN: {
    name: 'TOURNAMENT_WIN',
    component: () => <WinnerTournamentModal />,
    authOnly: true,
    priority: 10
  },
  TOURNAMENT_LOW_LEVEL: {
    name: 'TOURNAMENT_LOW_LEVEL',
    component: () => <TournamentRequiredLevel />,
    authOnly: true,
    priority: 100
  },
  GAME_NOTIFICATION: {
    name: 'GAME_NOTIFICATION',
    component: () => <GameNotificationModal />,
    authOnly: false,
    priority: 60
  },
  EVENT_MODAL: {
    name: 'EVENT_MODAL',
    component: () => <EventModal />,
    authOnly: true,
    priority: 60
  },
  FULLSCREEN_IMAGE: {
    name: 'FULLSCREEN_IMAGE',
    component: () => <FullScreenImageModal />,
    authOnly: false,
    priority: 100
  },
  BACK_TO_SIGNUP: {
    name: 'BACK_TO_SIGNUP',
    component: () => <BackToSignupModal />,
    authOnly: false,
    priority: 100
  },
  VIP_RULES: {
    name: 'VIP_RULES',
    component: () => <VipRulesModal />,
    authOnly: false,
    priority: 100
  },
  IOSSETUP: {
    name: 'IOSSETUP',
    component: () => <IosSetupModal />,
    authOnly: false,
    priority: 100
  },
  NO_COINS_FOR_FREESPIN: {
    name: 'NO_COINS_FOR_FREESPIN',
    component: () => <NoCoinsForFreespinsModal />,
    authOnly: true,
    priority: 100
  },
  NO_COINS_FOR_MONEY: {
    name: 'NO_COINS_FOR_MONEY',
    component: () => <NoCoinsForMoneyModal />,
    authOnly: true,
    priority: 100
  },
  BUY_FREESPINS: {
    name: 'BUY_FREESPINS',
    component: () => <BuyFreespinsModal />,
    authOnly: true,
    priority: 100
  },
  BUY_MONEY: {
    name: 'BUY_MONEY',
    component: () => <BuyMoneyModal />,
    authOnly: true,
    priority: 100
  },
  SUPPORT: {
    name: 'SUPPORT',
    component: () => <SupportModal />,
    authOnly: true,
    priority: 100
  },
  SEARCH: {
    name: 'SEARCH',
    component: () => <SearchModal />,
    authOnly: false,
    priority: 100
  },
  NO_COINS_FOR_FREESPIN_EVENT: {
    name: 'NO_COINS_FOR_FREESPIN_EVENT',
    component: () => <NoCoinsForFreespinsEventModal />,
    authOnly: true,
    priority: 100
  },
  NO_COINS_FOR_MONEY_EVENT: {
    name: 'NO_COINS_FOR_MONEY_EVENT',
    component: () => <NoCoinsForMoneyEventModal />,
    authOnly: true,
    priority: 100
  },
  BUY_FREESPINS_EVENT: {
    name: 'BUY_FREESPINS_EVENT',
    component: () => <BuyFreespinsEventModal />,
    authOnly: true,
    priority: 100
  },
  BUY_MONEY_EVENT: {
    name: 'BUY_MONEY_EVENT',
    component: () => <BuyMoneyEventModal />,
    authOnly: true,
    priority: 100
  },
  PROFILE_REQUIREMENTS: {
    name: 'PROFILE_REQUIREMENTS',
    component: () => <ProfileRequirementsModal />,
    authOnly: false,
    priority: 100
  },
  EVOLUTION_WARNING: {
    name: 'EVOLUTION_WARNING',
    component: () => <EvolutionWarning />,
    authOnly: false,
    priority: 100
  },
  JACKPOTS_WIN: {
    name: 'JACKPOTS_WIN',
    component: () => <JackpotsWin />,
    authOnly: false,
    priority: 50
  }
};
